import React from 'react';
import './ie.polyfills';
import { checkZoneRedirect } from './utils/zoneSwitch';
import { createRoot } from 'react-dom/client'; // <-- Используем createRoot вместо render
import { BrowserRouter as Router } from 'react-router-dom';
import Routes from './Router';
import './fonts.css';
import './normalize.css';
import './milligram.min.css';
import './index.css';
import './i18n';
import i18n from 'i18next';
import axios from 'axios';
import { globalConfig, globalConfigUrl, defaultConfig } from './configuration/config';
import { Provider } from 'react-redux';
import { store } from './store/store';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement); // <-- Создаём root для React 18

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('Service Worker registered with scope:', registration.scope);
      })
      .catch((error) => {
        console.log('Service Worker registration failed:', error);
      });
  });
} else {
  console.log('Service Worker is not supported by this browser.');
}

// Функция, которая рендерит приложение
const renderApp = () => {
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <Router>
          <Routes />
        </Router>
      </Provider>
    </React.StrictMode>,
  );
};

axios.defaults.headers.common['Accept-Language'] = i18n.language;

i18n.on('languageChanged', (lng) => {
  axios.defaults.headers.common['Accept-Language'] = lng;
});

// Редирект между зонами — до рендера
if (checkZoneRedirect()) {
  // noop — страница перенаправляется
} else {

// Загружаем конфигурацию перед рендерингом
axios
  .get(`${window.location.origin}/${globalConfigUrl}`)
  .then((response) => {
    globalConfig.config = response.data;
  })
  .catch((e) => {
    globalConfig.config = defaultConfig;
  })
  .finally(() => {
    console.log(globalConfig.config);
    renderApp(); // <-- Вызываем рендеринг после загрузки конфига
  });
}
